export const REPORT_NAME = 'User\'s Associated Browsers';
export const GET_USERS_TASK_NAME = 'user-associated-browsers-report.get-users';
export const GET_USERS_TASK_PROGRESS_LABEL = 'Searching for users for the report...';
export const TASK_NAME = 'user-associated-browsers-report.get-users';
export const FILE_NAME = `PitchBook-user's-associated-browsers-report`;
export const STATIC_FILE_HEADERS = {
    userId: 'User ID',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    cookieId: 'Cookie ID',
    browserId: 'Browser ID',
    browserType: 'Browser Type',
    deviceType: 'Device Type',
    createdDate: 'Created Date',
    lastAccessDate: 'Last Access Date',
    registered: 'Registered',
    registeredDate: 'Registered Date',
    deactivated: 'Deactivated',
    deactivatedDate: 'Deactivated Date',
    deactivatedReason: 'Deactivated Reason',
    ipAddress: 'IP Address',
    domain: 'Domain',
    country: 'Country',
    state: 'State',
    city: 'City',
};

export const CHUNK_SIZE = 100;


export const DATE_RANGE_NAME = 'associated-browsers-data-range-select';
export const DATE_RANGE_OPTIONS = {
    CUSTOM: {
        value: 'custom',
        label: 'Custom',
    },
    LAST_MONTH: {
        value: 'last-month',
        label: 'Last Month',
    },
    CURRENT_LICENSE: {
        value: 'current-license',
        label: 'Current License',
    },
};

export const SELECT_NAME = 'associated-browsers-report-select';
export const SELECT_OPTIONS = {
    USERS: {
        value: 'users',
        label: 'Users',
    },
    GROUPS: {
        value: 'groups',
        label: 'Group',
    },
};
